import { AI_API_URL } from "@api/constant";

export default async function fetchSummary(messageList, userId, setAiSummary) {
	return null;
	try {
		const response = await fetch(`${AI_API_URL}/summarise-conversation`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				conversation: messageList.map((item) => {
					return {
						text: item.text,
						user: item.user._id === userId ? 'self' : 'other',
						createdAt: item.createdAt,
					};
				}),
			}),
		});

		const data = await response.json();
		//Find summary in the data Object
		console.log(data.raw);

		let summary;
		try {
			summary = JSON.parse(data.raw).summary;
			console.log('summary:', summary);
			if (summary) {
				return JSON.stringify(summary);
			}
		} catch (error) {
			try {
				const parsedData = JSON.parse(data);
				summary = parsedData.summary;
				console.log('parsed summary:', summary);
				if (!summary || typeof summary != 'string' || !summary.length) {
					//Look for suggested_messages in the data object
					const suggestedMessages = parsedData.suggested_messages;
					return suggestedMessages;
				}
				setAiSummary(parsedData.raw);
			} catch (parseError) {
				console.error('Error parsing summary:', parseError);
			}
		}

		// console.log(data, 'data');
	} catch (error) {
		console.error('Error fetching summary:', error);
	}
};
